<script>
  import { quintOut } from "svelte/easing";
  import { crossfade } from "svelte/transition";
  import { flip } from "svelte/animate";

  const [send, receive] = crossfade({
    duration: d => Math.sqrt(d * 300),
    fallback(node, params) {
      const style = getComputedStyle(node);
      const transform = style.transform === "none" ? "" : style.transform;

      return {
        duration: 600,
        easing: quintOut,
        css: t => `
                transform: ${transform} scale(${t});
                opacity: ${t}
            `
      };
    }
  });
  let ItemAnimation = false;
  const handleMouseenter = () => (ItemAnimation = true);
  const handleMouseleave = () => (ItemAnimation = false);
</script>

<style>
  .floating {
    animation-name: floating;
    animation-duration: 1.911s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  @keyframes floating {
    from {
      transform: translate(0, 0px);
    }
    50% {
      transform: translate(0, 45px);
    }
    to {
      transform: translate(0, -0px);
    }
  }
</style>

<div id="more-features" class="container-fluid">
  <div class="container" id="OurServices">
    <div class="row">
      <div class="col-md-12">
        <div class="row-title">خدماتنا</div>
      </div>
    </div>
    <div
      class="row"
      class:floating={ItemAnimation}
      on:mouseenter={handleMouseenter}
      on:mouseleave={handleMouseleave}>
      <div class="col-sm-6 col-md-3">
        <div class="mfeature-box">
          <div class="mfeature-icon">
            <div class="icon-img ">
              <img src="svg/1.svg" alt="" />
            </div>
          </div>
          <div class="mfeature-title">
             توفير الطاقة 
            <br />
            منتجات التحكم 
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-3" alt="Borat">
        <div class="mfeature-box">
          <div class="mfeature-icon">
            <div class="icon-img ">
              <img src="svg/4.svg" alt="" />
            </div>
          </div>
          <div class="mfeature-title">المكاتب والمنازل الذكية</div>
        </div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div class="mfeature-box">
          <div class="mfeature-icon">
            <div class="icon-img ">
              <img src="svg/3.svg" alt="" />
            </div>
          </div>
          <div class="mfeature-title">
             استبدال وصيانة
            <br />
            المكيفات
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div class="mfeature-box">
          <div class="mfeature-icon">
            <div class="icon-img ">
              <img src="svg/2.svg" alt="" />
            </div>
          </div>
          <div class="mfeature-title">
            توفير وتركيب 
            <br />
            الستائر الهوائية
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div id="more-features" class="container-fluid coolBG1">
  <div class="container ">
    <div class="row">
      
      <div id="coolBG1Content" class="col-sm-6 col-md-6">
        <h1> أفكار صغيره  مدخرات كبيرة !</h1>
        <p>
 بتوفير حوالي 80% من استهلاك الطاقة في المؤسسة او المنزل . ومع ارتفاع معدلات التضخم في الكهرباء فإن   HVAC  تساهم تقنية
  تستحق ان تركز عليها وان تضعها في اعتبارك. HVAC  
فكرة استبدال نظام التكييف شيء رائع ولكنه يتطلب مبالغ كبيرة. فاذا كنت تبحث عن اقل تكلفة فلابد من حلول ذكية للحد من الطاقة الضائعة ومؤكد انت في حاجة الي حلول وضوابط مبتكرة. وتقدم شركتنا منذ بدايتها مجموعة واسعة من الحلول لتعزيز الكفاءة ايماناً منا بانه لا شيء سينجح اذ تم حماية موارد الطبيعة بشكل خاطئ 
        </p>
      </div>
<div class="col-sm-6 col-md-6">
        <!-- <div class="coolBG1Sub" /> -->
      </div>
    </div>

  </div>
</div>
